export const CHECK_MY_PAPER_TEST_ID = 'check-paper-btn'
export const GO_BACK_TO_CITATIONS_TEST_ID = 'go-back-to-citations-btn'
